export enum SwapQualityIssue {    
    NoIssue = 1,
    DonorSurgery = 2,
    RecipientSurgery = 4,
    Logistics = 8,
    Packaging = 16
}